import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';

@Injectable()
export class JsonPartnerService {
  constructor(private http: HttpClient) {}

  url = 'http://localhost:3001/';

  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  getPartners(): Observable<any[]> {
    const partnerUrl = this.url + 'partners';

    return this.http
      .get<any[]>(partnerUrl, { headers: this.headers, responseType: 'json' })
      .pipe(catchError(this.handleError<any[]>('getPartners', [])));
  }

  validateApi(): boolean {
    const value = Math.random() >= 0.5;
    return value;
  }

  addPartner(partner: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const partnerUrl = this.url + 'partners';

    return this.http.post<any>(partnerUrl, partner, { headers });
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(`${operation} failed: ${error.message}`);

      return of(result as T);
    };
  }

  callPartnerMethod(partnerId: number, methodId: string, methodType: string, body: any = {}): Observable<any> {
    const methodUrl = `${this.url}partners/${partnerId}/${methodId}`;
    switch (methodType) {
      case 'GET':
        return this.http.get<any>(methodUrl, { headers: this.headers });
      case 'POST':
        return this.http.post<any>(methodUrl, body, { headers: this.headers });
      case 'PUT':
        return this.http.put<any>(methodUrl, body, { headers: this.headers });
      case 'DELETE':
        return this.http.delete<any>(methodUrl, { headers: this.headers });
      default:
        throw new Error(`Unsupported method type: ${methodType}`);
    }
  }
}
